<div class="reports-container">
  <div class="close-btn"><button class="nrk-button" (click)="onClose()">X</button></div>


  <div class="reports">
    <ng-container *ngFor="let search of searches; index as idx">
      <ngx-reports-printer #reportsPrinter [search]="search" [pdfSidebar]="true" [dashboard]="true" [isPopup]="true">
      </ngx-reports-printer>
      <br><br>
      <div class="text-center"><button class="btn btn-primary btn-lg" (click)="onDownloadPdf(search, idx)">Download PDF</button></div>
      <br><br>
    </ng-container>
  </div>

</div>
